import { httpClient } from 'modules/common/api/http-client';

export interface LoginRequestModel {
  username: string;
  password: string;
  returnurl: string;
  rememberlogin: boolean;
}

export interface CredentialsRequestModel {
  username: string;
  password: string;
  returnurl: string;
  deviceFingerprint?: string;
}

export interface OtpRequestModel {
  token: string;
  otp: string;
  trustDevice: boolean;
}

export enum UserType {
  MASTERADMIN = 'masterAdmin',
  BACKOFFICE = 'backoffice',
}

export interface CredentialsResponseModel {
  token: string;
  userType: UserType;
  twoFaInfo: {
    url: string;
    key: string;
    qrInBase64: string;
  } | null;
}

export function login(data: LoginRequestModel) {
  return httpClient.post('/api/v1/acc/login', data);
}

export function credentials(data: CredentialsRequestModel) {
  return httpClient.post('/api/v1/twofa/credentials', data);
}

export function otp(data: OtpRequestModel) {
  return httpClient.post('/api/v1/twofa/otp', data);
}

export const resetApi = {
  async resetPassword(sendPassword: { password: string; code: string }) {
    return await httpClient.post(`/api/v1/twofa/passwordcode/${sendPassword.code}`, {
      password: sendPassword.password,
    });
  },
  async getResetPasswordCode(code: string) {
    return httpClient.get(`/api/v1/twofa/passwordcode/${code}`);
  },
};
